import request from "@/utils/request";

//获取会员展示图片
export function getFriendLinkImages() {
  return request({
    url: "/friendlink/list",
    method: "get"
  });
}

